import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { actionTypes } from '../../constants';
import { sortArray, onFormInputKeyDown } from '../helpers/HelperFunctions';
import { TableColumn } from './TableColumn';
export class TableRow extends Component {
    static propTypes = {
        handleUpdate: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            checked: false
        };
        this.handlerCheck = this.handlerCheck.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onRowDoubleClick = this.onRowDoubleClick.bind(this);
        this.onDocLinkClick = this.onDocLinkClick.bind(this);
    }
    componentDidMount() {
        const { item, disableSelection } = this.props;
        const currentObject = this;
        var row = document.getElementById("table_row_" + item.columns.Id);

        if (!disableSelection) {
            row.addEventListener("contextmenu", function (event) {
                event.preventDefault();
                var ckeckBox = document.getElementById(item.columns.Id);
                ckeckBox.checked = !ckeckBox.checked;
                currentObject.handlerCheck({ target: ckeckBox });
            }, false);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.checked !== prevProps.checked) {
            this.setState({ checked: this.props.checked });
        }
    }
    handlerCheck(event) {
        this.setState({ checked: event.target.checked });
        if (this.props.handlerCheck)
            this.props.handlerCheck(event);
    }
    renderCols(item, cols) {
        if (!item || !cols)
            return '';
        const { checked } = this.state;
        if (item.actions && item.actions.length > 0)
            sortArray(item.actions, "sortIndex");
        return (
            [
                (!this.props.disableSelection &&
                <TableColumn key={item.columns.Id}>
                    <input id={item.columns.Id} type="checkbox" onKeyDown={onFormInputKeyDown} onChange={this.handlerCheck} checked={checked} />
                    <label htmlFor={item.columns.Id} className="select-row-check-label"></label>
                </TableColumn>
                ),
                cols.map((col) => (
                    <TableColumn col={col} key={col.name} value={item.columns[col.name]} onDocLinkClick={() => item.columns && this.onDocLinkClick(item.columns.Id, item.actions)} />
                ))
            ]
        );
    }
    onRowClick(id) {
        if (id) {
            var ckeckBox = document.getElementById(id);
            ckeckBox.checked = !ckeckBox.checked;
            var event = { target: ckeckBox };
            this.handlerCheck(event);
        }
    }
    onDocLinkClick(id, actions) {
        if (id && actions && actions.length > 0) {
            let actionIndex = actions.findIndex(act => act.type === actionTypes.preview || act.type === actionTypes.edit || act.type === actionTypes.download);
            if (this.props.handlerAction && actionIndex >= 0)
                this.props.handlerAction(actions[actionIndex].type, [id]);
        }
    }
    onRowDoubleClick(id, actions) {
        if (!this.props.allowDoubleClickAction) {
            var ckeckBox = document.getElementById(id);
            ckeckBox.checked = true;
            var event = { target: ckeckBox };
            this.handlerCheck(event);
        }
        else {
            this.onDocLinkClick(id, actions);
        }
    }
    render() {
        const { children, cols, item, disableSelection } = this.props;
        if (cols && item)
            return (
                <tr id={"table_row_" + item.columns.Id} className={this.state.checked ? "active" : ""} onDoubleClick={() => !disableSelection && item.columns && this.onRowDoubleClick(item.columns.Id, item.actions)} onClick={() => !disableSelection && item.columns && this.onRowClick(item.columns.Id)}>
                    {this.renderCols(item, cols)}                    
                </tr>
            );
        return (
            <tr className={this.state.checked ? "active" : ""}>
                {children}
            </tr>
        );
    }
}
